/**
 *
 * @typedef Description
 * @returns {{get(): Promise, save(files: Object[]): Promise}}
 */
export const Description = axios => ({
  /**
   * Update profile description
   *
   * @param payload: string
   * @param slug: string
   * @returns Promise
   */
  update(slug, payload) {
    return axios.put(`/v1/profiles/${slug}/description`, payload)
  },
  /**
   * Get profile description
   *
   * @param slug: string
   * @returns Promise
   */
  get(slug) {
    return axios.get(`/v1/profiles/${slug}/description`)
  }
})
